<script setup>
// No assistant yet (phase 4.8, D-P7 with R2-4-3 = A): the kit's "All roles" page with one card — the woot's
// assistant has no type, so there is one way to start, not five roles — and nothing behind it. The card's art is the
// Polaris animation on the kit's field (PolarisArt, PROVISÓRIO: R2-4-4 → X-4 = B). "Create assistant" opens the
// dialog the page already had, for whoever may create one.
import { useI18n } from 'vue-i18n';
import { Add16 } from '@carbon/icons-vue';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import { Card, CardContent } from 'dashboard/components-next/polaris/ui/card';
import PolarisArt from 'dashboard/components-next/polaris/art/PolarisArt.vue';
import Policy from 'dashboard/components/policy.vue';

const emit = defineEmits(['click']);
const { t } = useI18n();
</script>

<template>
  <section class="grid gap-6" data-no-assistants>
    <div class="grid gap-1">
      <h2 class="type-polaris-section-title">
        {{ t('POLARIS.ASSISTANTS.EMPTY_STATE.TITLE') }}
      </h2>
      <p class="max-w-prose type-polaris-body text-polaris-muted-foreground">
        {{ t('POLARIS.ASSISTANTS.EMPTY_STATE.SUBTITLE') }}
      </p>
    </div>
    <Card class="w-full max-w-sm gap-0 py-0">
      <div class="p-2">
        <PolarisArt class="h-40" />
      </div>
      <CardContent class="grid gap-2 px-5 pb-5 pt-3">
        <h3 class="type-polaris-card-title">
          {{ t('POLARIS.ASSISTANTS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE') }}
        </h3>
        <p class="type-polaris-body text-polaris-muted-foreground">
          {{ t('POLARIS.PAGES.NO_ASSISTANTS.CARD_TEXT') }}
        </p>
        <Policy :permissions="['administrator']" class="mt-2">
          <Button size="sm" @click="emit('click')">
            <Add16 aria-hidden="true" />
            {{ t('POLARIS.ASSISTANTS.ADD_NEW') }}
          </Button>
        </Policy>
      </CardContent>
    </Card>
  </section>
</template>
